import React from 'react';
import { useI18nContext } from '@ecg-internal/js-react-i18n';
import { AvatarImage, Icon, LogoImage } from '@hz-design-system/web-ui';

import Classes from './SellerProfilePicture.module.scss';

type TSellerProfilePicturesProps = {
  name: string;
  isLogo: boolean;
  isLargeLogo?: boolean;
  imageSrc?: string;
};

const SellerProfilePicture = ({ imageSrc = '', name, isLogo, isLargeLogo }: TSellerProfilePicturesProps) => {
  const { t } = useI18nContext();

  if (isLogo) {
    return (
      <div
        className={`${Classes.logoContainer} ${isLargeLogo ? Classes.logoContainerLarge : ''}`}
        {...(imageSrc && { style: { backgroundImage: `url(${imageSrc})` } })}
      >
        <LogoImage
          src={imageSrc}
          alt={`${name} ${t('sellerInfo.profilePictures.logoAltText')}`}
          placeholderIconName="shop"
          size={isLargeLogo ? 'l' : 'm'}
        />
      </div>
    );
  }

  if (!imageSrc) {
    return (
      <div className={Classes.avatarPlaceholderContainer}>
        <Icon name="profile" />
      </div>
    );
  }

  return (
    <div className={Classes.avatarContainer}>
      <AvatarImage src={imageSrc} alt={name} placeholderIconName="profile" />
    </div>
  );
};

export default SellerProfilePicture;
